// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { MaintenanceActions } from "../../redux/maintenance";
import Button from "../reusable/Button";

class ReportReminders extends Component<{
  getGreenDealReportReminderTemplate: () => *,
  sendGreenDealReportReminders: () => *,
  greenDealReportReminderTemplate: *,
  sendGreenDealReportRemindersNotification: *,
}> {
    constructor(props) {
        super(props);
        this.state = {
            selectedCommitment: 'ALL_GREEN_DEALS'
        };
    }

    updateSelected = (e) => {
        this.setState({selectedCommitment: e.target.value});
        this.props.getGreenDealReportReminderTemplate(e.target.value);


    }

  componentDidMount() {
    this.props.getGreenDealReportReminderTemplate();
  }

  sendGreenDealReportRemindersClicked = () => {
    if (window.confirm("Haluatko varmasti lähettää raportointimuistutukset?")) {
      this.props.sendGreenDealReportReminders(this.state.selectedCommitment);
    }
  };

  render() {
    const template = this.props.greenDealReportReminderTemplate;
    const notification = this.props.sendGreenDealReportRemindersNotification;
    const inProgress = notification && notification.state === "IN_PROGRESS";
    const success = notification && notification.state === "SUCCESS";
    const failure = notification && notification.state === "FAILURE";

    const templateExists = template && template.subject && template.body;

    return template ? (
      <div>
        <p><h2>Lähetä raportointimuistutukset</h2></p>
        Valitse sopimus: <nbsp/>
        <select id="commitment_report_selector" onChange={this.updateSelected} value={this.state.selectedCommitment}>
          <option value="PERSONAL_COMMITMENTS">Henkilökohtaiset sitoumukset</option>
          <option value="COMMITMENT">Toimenpidesitoumukset</option>
          <option value="NUTRITION">Ravitsemussitoumukset</option>
          <option value="ALL_GREEN_DEALS">Kaikki Green deal sitoumukset</option>
          <option value="PLASTIC_BAG">Muovikassi GD</option>
          <option value="AUTOMOTIVE_INDUSTRY">Autoala GD</option>
          <option value="OIL_INDUSTRY">Öljyjätehuolto GD</option>
          <option value="WORK_MACHINE">Työkoneala GD</option>
          <option value="DEMOLITION">Purkujäte GD</option>
          <option value="CONSTRUCTION_PLASTICS">Rakentamisen muovit GD</option>
          <option value="EMISSION_FREE_WORKSITE">Päästötön työmaa GD</option>
          <option value="EARLY_CHILDHOOD_EDUCATION">Varhaiskasvatuksen GD</option>
          <option value="GREEN_DEAL">Luokittelemattomat Green dealit</option>
          <option value="MATERIAL">Materiaalitehokkuus</option>
          <option value="WASTEWATER">Jäteveden puhdistaminen</option>
          <option value="GROCERY_INDUSTRY">Muoviset annospakkaukset</option>
          <option value="GROCERY_INDUSTRY_WITH_MATERIAL">Muoviset annospakkaukset (GD & MATSIT)</option>
        </select>
        <Button
          disabled={!templateExists || inProgress}
          onClick={this.sendGreenDealReportRemindersClicked}
        >
          {inProgress ? "Sending..." : "Send report reminders"}
        </Button>
        {success && <div>Reminders sent!</div>}
        {failure && <div>{"ERROR! " + notification.message}</div>}

        <h2>Sähköpostinviestin esikatselu:</h2>
        <h3>{template.subject}</h3>
        <p>{template.body}</p>
        <div>{template.error}</div>
      </div>
    ) : (
      <div />
    );
  }
}

export default connect(
  state => ({
    greenDealReportReminderTemplate:
      state.maintenance.greenDealReportReminderTemplate,
    sendGreenDealReportRemindersNotification:
      state.maintenance.sendGreenDealReportRemindersNotification
  }),
  {
    getGreenDealReportReminderTemplate:
      MaintenanceActions.getGreenDealReportReminderTemplate,
    sendGreenDealReportReminders:
      MaintenanceActions.sendGreenDealReportReminders
  }
)(ReportReminders);



// WEBPACK FOOTER //
// ./src/components/maintenance/ReportReminders.js